<header>
  <h5>Kurv</h5>
  <button mat-icon-button (click)="closeAltMenu()" aria-label="Luk kurven">
    <mat-icon>close_icon</mat-icon>
  </button>
</header>
<section>
  <abook-basket></abook-basket>
</section>
